import React from "react";
import {ClickAwayListener, Tooltip} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import WarningIcon from '@material-ui/icons/Warning';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: 'max-content',
        borderRadius: '10px',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        boxShadow: '0px -2px 10px 0px #363D4D88',
    },
    heading: {
        width: '100%',
        textAlign: "center",
        backgroundColor: theme.palette.green.dark,
        borderRadius: '10px 10px 0px 0px',
        color: 'white',
        fontSize: '20px',
        padding: theme.spacing(2),
    },
    text: {
        marginTop: theme.spacing(2),
        color: theme.palette.grey.price,
        fontSize: '16px',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        textAlign: 'start',
        fontWeight: 600,
        lineHeight: 1.43,
    },
    contentContainer: {
        display: 'flex'
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '20px 0px',
      marginLeft: theme.spacing(2),
    },
    warningIcon: {
        color: '#FFC101'
    }
}));

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.white,
    },
    tooltip: {
        backgroundColor: 'transparent',
        height: 'max-content',
        padding: 0
    },
}));

const AlarmTooltip = ({children, heading, text, open, onClose}) => {
    const classes = useStylesBootstrap();
    const cl = useStyles();

    return (
        <ClickAwayListener onClickAway={onClose}>
            <div>
                <Tooltip open={open}
                         onClose={onClose}
                         disableFocusListener
                         disableHoverListener
                         disableTouchListener
                         arrow
                         classes={classes}
                         placement="top"
                         title={(
                             <div className={cl.root}>
                                 <div className={cl.heading}>
                                     {heading}
                                 </div>
                                 <div className={cl.contentContainer}>
                                     <div className={cl.iconContainer}>
                                         <WarningIcon className={cl.warningIcon}/>
                                     </div>
                                     <Typography className={cl.text}>
                                         {text}
                                     </Typography>
                                 </div>
                             </div>
                         )}
                >
                    {children}
                </Tooltip>
            </div>
        </ClickAwayListener>
    )
};

export default AlarmTooltip;
